import { render, staticRenderFns } from "./MessageIcon.vue?vue&type=template&id=23314bf9&"
import script from "./MessageIcon.vue?vue&type=script&lang=js&"
export * from "./MessageIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports